
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopansharpurtaxi() {



  const cardData =
  {
    keyword: 'Pune to Pandharpur Taxi Service',
    heading: 'AB Ghule Cabs: Pune to Pandharpur Taxi Service',
    headingDescription: 'AB Ghule Cabs offers reliable and comfortable Pune to Pandharpur taxi services. Whether you are traveling for a religious pilgrimage or leisure, our fleet of well-maintained vehicles and professional drivers will ensure a smooth and safe journey. With competitive pricing, excellent customer service, and flexible options, we make your trip to Pandharpur comfortable and hassle-free. Pune to Pandharpur is approximately 180 km.',

    top: 'Top Places to Visit in Pandharpur with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Vithoba Temple",
    description: "The most prominent attraction in Pandharpur, the Vithoba Temple is dedicated to Lord Vithoba (a form of Lord Krishna). It is one of the holiest pilgrimage sites in Maharashtra and is known for its spiritual significance."
  },
  {
    title: "Ashtavinayak Temple",
    description: "Situated on the banks of the Chandrabhaga River, this temple is dedicated to Lord Ganesha and holds immense religious value. It is one of the main attractions for devotees visiting Pandharpur."
  },
  {
    title: "Chandrabhaga River",
    description: "This sacred river is located near the Vithoba Temple and is an important part of Pandharpur's spiritual and cultural heritage. Pilgrims take a holy dip in the river for purification."
  },
  {
    title: "Pandharpur Wari",
    description: "A significant event, the Pandharpur Wari is an annual pilgrimage to the Vithoba Temple, where thousands of devotees walk barefoot from various regions to Pandharpur to seek blessings."
  },
  {
    title: "Bhuikot Fort",
    description: "A historical fort located near Pandharpur, Bhuikot Fort offers a glimpse into the city's rich history and is a good spot for history enthusiasts and photographers."
  },
  {
    title: "Bhima Shankar Temple",
    description: "Located about 25 km from Pandharpur, Bhima Shankar is another important pilgrimage site dedicated to Lord Shiva, making it an ideal visit if you're interested in exploring nearby spiritual sites."
  },
  {
    title: "Khandoba Temple",
    description: "Situated in the heart of the town, the Khandoba Temple is dedicated to Lord Khandoba, a deity widely worshipped in Maharashtra. It is another important temple to visit while in Pandharpur."
  },
  {
    title: "Vishnupad Temple",
    description: "A sacred site dedicated to Lord Vishnu, Vishnupad Temple is located on the banks of the Chandrabhaga River and is an essential visit for those seeking spiritual solace."
  },
  {
    title: "Tulja Bhavani Temple",
    description: "Located about 40 km from Pandharpur, this temple is dedicated to Goddess Bhavani and is an important religious site for pilgrims visiting the region."
  },
  {
    title: "Siddheshwar Temple",
    description: "Situated in the town of Solapur, about 45 km from Pandharpur, Siddheshwar Temple is dedicated to Lord Shiva and is another important spiritual destination for pilgrims."
  }
],


services: [
    {
      "name": "Pune to Pandharpur Cab Services",
      description: "AB Ghule Cabs provides efficient and reliable cab services from Pune to Pandharpur. Whether you're visiting for a religious trip or a family vacation, our taxis are the best option for a hassle-free journey."
    },
    {
      "name": "Pune to Pandharpur Taxi Service",
      description: "For a comfortable and smooth journey from Pune to Pandharpur, choose AB Ghule Cabs. Our taxi services ensure a timely, safe, and comfortable ride with professional drivers familiar with the best routes."
    },
    {
      "name": "Pune to Pandharpur Car Hire",
      description: "AB Ghule Cabs offers convenient car hire services for your trip from Pune to Pandharpur. Choose from a variety of vehicles to suit your needs and enjoy the comfort of a private, air-conditioned ride."
    },
    {
      "name": "Pune to Akkalkot Taxi Service",
      description: "If you are looking for a taxi service from Pune to Akkalkot, AB Ghule Cabs offers reliable and comfortable travel. Our drivers are experienced and will ensure a timely and smooth journey."
    },
    {
      "name": "Pune to Akkalkot Taxi Booking",
      description: "Book your taxi from Pune to Akkalkot easily with AB Ghule Cabs. Enjoy competitive prices and excellent service with our online booking platform for a quick and seamless experience."
    },
    {
      "name": "Pune to Akkalkot Car Hire",
      description: "AB Ghule Cabs offers affordable car hire options for your trip from Pune to Akkalkot. Whether you need a small car or a larger vehicle for group travel, we provide well-maintained cars to ensure comfort."
    },
    {
      "name": "Pune to Akkalkot Darshan Taxi",
      description: "Book your darshan taxi to Akkalkot with AB Ghule Cabs. We offer dedicated taxi services that are perfect for your spiritual journey, ensuring a comfortable ride for your visit to the holy site."
    },
    {
      "name": "Pune to Tuljapur Taxi Service",
      description: "Travel from Pune to Tuljapur with AB Ghule Cabs. Our taxi services provide comfort and reliability, ensuring that you reach your destination on time for a peaceful visit to the temple."
    },
    {
      "name": "Pune to Tuljapur Car Rental",
      description: "AB Ghule Cabs offers affordable and flexible car rental services for your trip from Pune to Tuljapur. Whether you're traveling solo or with a group, our vehicles are perfect for a comfortable journey."
    },
    {
      "name": "Pune to Solapur Taxi Service",
      description: "For a smooth and timely journey, choose AB Ghule Cabs for your Pune to Solapur taxi service. We provide well-maintained cars and experienced drivers to ensure comfort throughout your trip."
    },
    {
      "name": "Pune to Solapur One-Way Taxi",
      description: "Need a one-way taxi from Pune to Solapur? AB Ghule Cabs offers one-way taxi services with affordable pricing and flexible schedules, so you can travel at your convenience."
    },
    {
      "name": "Pune to Pandharpur Tempo Traveller Hire",
      description: "For group travel, book a tempo traveller from Pune to Pandharpur with AB Ghule Cabs. Our spacious and comfortable tempo travellers are perfect for family or group trips."
    },
    {
      "name": "Innova Taxi from Pune to Solapur",
      description: "Travel from Pune to Solapur in style and comfort with an Innova taxi from AB Ghule Cabs. Our Innova taxis offer ample space and luxury features to ensure a smooth and relaxing ride."
    },
    {
      "name": "Pune to Solapur Ertiga Taxi",
      description: "For a compact and comfortable ride from Pune to Solapur, choose an Ertiga taxi from AB Ghule Cabs. Ideal for small families or groups, the Ertiga offers both comfort and affordability."
    },
    {
      "name": "Pune to Tuljapur Innova Crysta Taxi",
      description: "Book an Innova Crysta taxi for your trip from Pune to Tuljapur with AB Ghule Cabs. This premium vehicle ensures luxury, comfort, and a smooth ride for your spiritual journey."
    },
    {
      "name": "Pune to Tuljapur to Akkalkot to Gangapur Cab Package",
      description: "AB Ghule Cabs offers a special cab package covering Pune to Tuljapur, Akkalkot, and Gangapur. This customized package ensures you visit all the significant religious sites comfortably and at your own pace."
    },
    {
      "name": "Pune to Pandharpur Taxi Fare",
      description: "The taxi fare for your journey from Pune to Pandharpur with AB Ghule Cabs is both affordable and transparent. We offer competitive rates without compromising on quality or service."
    },
    {
      "name": "Pune to Pandharpur Cab Charges",
      description: "Our cab charges for the Pune to Pandharpur route are designed to fit your budget. AB Ghule Cabs provides clear, upfront pricing with no hidden fees, ensuring a hassle-free experience."
    },
    {
      "name": "Pune to Pandharpur Taxi Booking Online",
      description: "Booking your taxi from Pune to Pandharpur has never been easier. With AB Ghule Cabs’ online booking platform, you can easily schedule your ride and ensure a comfortable, timely trip."
    },
    {
      "name": "Pune to Pandharpur Car Rental Service",
      description: "AB Ghule Cabs offers car rental services for your trip from Pune to Pandharpur. Choose from a variety of well-maintained vehicles, including sedans, SUVs, and more, to suit your travel needs."
    },
    {
      "name": "Pune to Pandharpur Taxi Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Pandharpur Taxi. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pandharpur to Pune Cab", "- Pune to Pandharpur Cab"],
    ["Pune to Pandharpur Cab Service", "- Pune to Akkalkot Cab"],
    ["Pune to Akkalkot Taxi", "- Pune to Akkalkot Car Rental Price"],
    ["Pune to Akkalkot Darshan Package", "- Pune to Tuljapur Cab"],
    ["Pune to Tuljapur Cab Fare", "- Pune to Tuljapur Car Rental"],
    ["Pune to Solapur Cab", "- Pune to Solapur One Way Cab"],
    ["Pune to Pandharpur Tempo Traveller on Rent", "- Innova Taxi from Pune to Solapur"],
    ["Pune to Solapur Ertiga Taxi", "- Pune to Tuljapur Innova Crysta Taxi"],
    ["Pune to Tuljapur to Akkalkot to Gangapur Cab Package", "- Pune to Tuljapur Ertiga Cab"],
    ["Pune to Pandharpur Taxi Fare", "- Pune to Pandharpur Cab Charges"],
    ["Pune to Pandharpur Taxi Booking", "- Pune to Pandharpur Car Rental"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Timely Service",
      WhyChoosedescription: "At AB Ghule Cabs, we understand the importance of punctuality. Our drivers ensure you reach your destination on time, whether you are traveling for religious purposes, leisure, or business."
    },
    {
      WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
      WhyChoosedescription: "Our fleet includes a variety of vehicles to suit your needs, ranging from sedans to SUVs. All our vehicles are regularly maintained and cleaned, ensuring a comfortable and smooth ride to Pandharpur."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "We employ experienced, courteous, and professional drivers who are familiar with the Pune to Pandharpur route. They are committed to your safety and comfort throughout the journey."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive pricing for our Pune to Pandharpur taxi services. There are no hidden charges, and our fare structure is transparent, so you know exactly what to expect."
    },
    {
      WhyChooseheading: "Safe and Secure Travel",
      WhyChoosedescription: "The safety of our passengers is our top priority. All of our drivers undergo thorough background checks, and our vehicles are equipped with the necessary safety features for a secure trip."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether it’s an early morning trip or a late-night ride, AB Ghule Cabs is available 24/7 for your Pune to Pandharpur taxi needs. Our booking process is simple and accessible at any time."
    },
    {
      WhyChooseheading: "Customizable Travel Experience",
      WhyChoosedescription: "We offer personalized travel packages to suit your specific needs. Whether you’re traveling for religious darshan, a family trip, or other purposes, we tailor the journey to meet your preferences."
    },
    {
      WhyChooseheading: "Hassle-Free Booking",
      WhyChoosedescription: "Booking a cab with AB Ghule Cabs is easy and quick. You can make a booking online through our website or mobile app, or contact our customer service for assistance."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Pandharpur?',
      answer: 'You can book a taxi from Pune to Pandharpur by visiting our website, using our mobile app, or calling our customer service team. We make the booking process simple and convenient.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for the Pune to Pandharpur journey?',
      answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars, depending on your preferences and group size.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers experienced with the Pune to Pandharpur route?',
      answer: 'Yes, our drivers are experienced, familiar with the route, and are committed to providing a safe and comfortable journey.',
    },
    {
      id: 'FAQ4',
      question: 'How much does the taxi from Pune to Pandharpur cost?',
      answer: 'The fare depends on the type of vehicle you choose and the distance. We offer affordable and transparent pricing, with no hidden charges.',
    },
    {
      id: 'FAQ5',
      question: 'Is the taxi service available for round trips to Pandharpur?',
      answer: 'Yes, we offer round-trip services for your convenience. You can book a taxi for both your journey to Pandharpur and back to Pune.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Extra charges may apply for waiting time or detours. However, we ensure that all charges are communicated upfront, so there are no surprises.',
    },
    {
      id: 'FAQ7',
      question: 'How far in advance should I book my taxi?',
      answer: 'We recommend booking your taxi at least a few hours in advance, especially for early morning trips. Booking early ensures vehicle availability and smooth travel.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking by contacting our customer service team. We try to accommodate changes as per your requirements.',
    },
    {
      id: 'FAQ9',
      question: 'Is it safe to travel with AB Ghule Cabs to Pandharpur?',
      answer: 'Absolutely. Your safety is our top priority. All of our drivers are background-checked, and our vehicles are regularly maintained to meet safety standards.',
    },
    {
      id: 'FAQ10',
      question: 'What if I need assistance during the trip?',
      answer: 'If you require assistance at any point during your journey, you can contact the driver or our customer service team. We are dedicated to ensuring a seamless experience for you.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Sunil Agarwal',
      feedback: 'I recently booked a taxi with AB Ghule Cabs for a trip to Pandharpur, and I had a wonderful experience. The vehicle was comfortable, the driver was professional, and the entire journey was smooth. I would highly recommend their services to anyone traveling to Pandharpur.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Meera Rani',
      feedback: 'AB Ghule Cabs made my trip to Pandharpur a pleasant experience. The driver was very courteous, and the ride was smooth and safe. I will definitely use their services again for my next trip.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Pandharpur Taxi | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Reliable and affordable Pune to Pandharpur taxi services with AB Ghule Cabs. Offering one-way, round-trip, and car rental services. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pandharpur to Pune Cab, Pune to Pandharpur Cab, Pune to Pandharpur Cab Service, Pune to Akkalkot Cab, Pune to Akkalkot Taxi, Pune to Akkalkot Car Rental Price, Pune to Akkalkot Darshan Package, Pune to Tuljapur Cab, Pune to Tuljapur Cab Fare, Pune to Tuljapur Car Rental, Pune to Solapur Cab, Pune to Solapur One Way Cab, Pune to Pandharpur Tempo Traveller on Rent, Innova Taxi from Pune to Solapur, Pune to Solapur Ertiga Taxi, Pune to Tuljapur Innova Crysta Taxi, Pune to Tuljapur to Akkalkot to Gangapur Cab Package, Pune to Tuljapur Ertiga Cab, Pune to Pandharpur Taxi Fare, Pune to Pandharpur Cab Charges, Pune to Pandharpur Taxi Booking, Pune to Pandharpur Car Rental" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Pandharpur Taxi | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Reliable and affordable Pune to Pandharpur taxi services with AB Ghule Cabs. Offering one-way, round-trip, and car rental services. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-pandharpur-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-pandharpur-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Pandharpur Taxi",
        description: "Reliable and affordable Pune to Pandharpur taxi services with AB Ghule Cabs. Offering one-way, round-trip, and car rental services. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-pandharpur-taxi",
        "logo": "https://abghulecabs.com/images/pune-to-pandharpur-taxi.jpg",
        "image": "https://abghulecabs.com/images/pune-to-pandharpur-taxi.jpg",
        "priceRange": "₹1200 - ₹4000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-pandharpur-taxi",
          "priceCurrency": "INR",
          "price": "1200",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi M"
            },
            "datePublished": "2024-11-25",
            "reviewBody": "AB Ghule Cabs provided excellent service for my trip to Pandharpur. The cab was clean and the driver was professional."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Nina S"
            },
            "datePublished": "2024-09-18",
            "reviewBody": "Great experience with the Pune to Pandharpur cab service. The driver was very knowledgeable and guided us throughout the trip."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Pandharpur Cabs",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-pandharpur-taxi"
        },
        "keywords": "Pandharpur to Pune Cab, Pune to Pandharpur Cab, Pune to Pandharpur Cab Service, Pune to Akkalkot Cab, Pune to Akkalkot Taxi, Pune to Akkalkot Car Rental Price, Pune to Akkalkot Darshan Package, Pune to Tuljapur Cab, Pune to Tuljapur Cab Fare, Pune to Tuljapur Car Rental, Pune to Solapur Cab, Pune to Solapur One Way Cab, Pune to Pandharpur Tempo Traveller on Rent, Innova Taxi from Pune to Solapur, Pune to Solapur Ertiga Taxi, Pune to Tuljapur Innova Crysta Taxi, Pune to Tuljapur to Akkalkot to Gangapur Cab Package, Pune to Tuljapur Ertiga Cab, Pune to Pandharpur Taxi Fare, Pune to Pandharpur Cab Charges, Pune to Pandharpur Taxi Booking, Pune to Pandharpur Car Rental"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/37.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetopansharpurtaxi;